import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  columns,
  // filters,
  searchBy,
} from "../../../service/AUAdvertisementService";

import { toast } from "react-toastify";
import BasicTable from "../../../components/Table/BasicTable";
import OrderModal from "../../Order/OrderModal/OrderModal";
import { ApproveUnapproveApi } from "../../../apis/a&uApi";

const AUAdvertisementComponent = ({
  disabledFilters,
  pagination,
  handlePagination,
}) => {
  const [search, setSearch] = useState("");
  const debounceTimeout = useRef(null);
  const [isOrderDetail, setIsOrderDetail] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [vendorData, setVendorData] = useState(null);
  const [promocodeData, setPromocodeData] = useState(null);

  const getAllAdvertise = async () => {
    try {
      const res = await ApproveUnapproveApi.getAllAdvertise(pagination, search);
      setPromocodeData(res?.data?.data);
    } catch (error) {
      toast.error(error?.message);
    }
  };

  const handleCloseOrderModal = () => {
    setIsOrderDetail(false);
    setSelectedOrder(null);
  };

  const handleCellClick = async (row, action) => {
    if (action === "Approved" || action === "Unapproved") {
      try {
        await ApproveUnapproveApi.updateAdvertiseApproval(row?._id, {
          status: action,
        });
        getAllAdvertise();
      } catch (error) {
        toast.error(error?.message);
      }
    }
    if (action === "order_id") {
      setSelectedOrder(row);
      setIsOrderDetail(true);
    }
    if (action === "vendor") {
      setVendorData(row);
    }
  };

  const onPaginatorClick = (e) => {
    if (e) {
      const data = {
        limit: e.rows,
        page: +e.page + 1,
      };
      handlePagination && handlePagination(data);
    }
  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  const handleClearFilter = () => {
    const clearPagination = {
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    };
    handlePagination && handlePagination({ clearPagination });
  };
  const handleFilter = (name, value) => {
    let data = {};
    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
    }

    console.log("data", data);
    handlePagination && handlePagination(data);
  };

  useEffect(() => {
    getAllAdvertise();
  }, [pagination, search]);

  // const DataFilter = filters.filter((f) =>
  //   disabledFilters ? !disabledFilters.includes(f.inputName) : true
  // );

  return (
    <div className="p-5">
      <BasicTable
        columns={columns}
        data={promocodeData?.advertisements}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: promocodeData?.limit || 5,
          sortField: null,
          sortOrder: null,
          totalPages: promocodeData?.totalPages || 1,
          totalCount: promocodeData?.totalCount || 1,
        }}
        onCellClick={(e) => {
          console.log("Cell Data", e);
        }}
        SearchBy={searchBy}
        handleSearch={debouncedSearch}
        handleFilter={(name, value) => handleFilter(name, value)}
        handleClearFilter={handleClearFilter}
        // filters={filters}
        selectedData={selectedOrder}
        handleCellClick={handleCellClick}
      />
      <OrderModal
        isOrderDetail={isOrderDetail}
        handleCloseOrderModal={handleCloseOrderModal}
        orderData={selectedOrder}
      />
      {/* <StoreModal
        itemData={vendorData}
        setToggleUsersDetails={(v) => {
          setVendorData(null);
        }}
        toggleUsersDetails={Boolean(vendorData)}
        fetchAllData={getAllAdvertise}
      /> */}
    </div>
  );
};

export default AUAdvertisementComponent;
